import React from 'react'
import RouteConstant from 'constants/RouteConstant'
import CommonLayout from 'layouts/Common'
import {Redirect, Route, Switch} from 'react-router-dom'
import RouteIf from 'routes/RouteIf'

import ProductOperationOrganizationList from 'pages/ProductOperationOrganization/ProductOperationOrganizationList'
import {AllUserRoles} from 'Authority'
import ProductInstitutionOperationHistory from 'pages/ProductInstitutionOperationHistory'

export default function ProductOperationOrganizationRoute() {
  return (
    <CommonLayout>
      <Switch>
        <RouteIf
          requiredRoles={AllUserRoles}
          path={RouteConstant.PRODUCTS_OPERATION_ORGANIZATION.path}
          exact
          component={ProductOperationOrganizationList}
        />
        <RouteIf
          path={RouteConstant.PRODUCTS_INSTITUTION_OPERATION_HISTORY.path}
          requiredRoles={AllUserRoles}
          exact
          component={ProductInstitutionOperationHistory}
        />
        <Route path='*'>
          <Redirect to={RouteConstant.ERROR_NOT_FOUND.path} />
        </Route>
      </Switch>
    </CommonLayout>
  )
}
